import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ConsoleAuthProvider } from './auth/ConsoleAuthProvider';
import { loadRuntimeConfig } from './config/runtime-config';
import '@shared/design-system/tokens.css';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
      refetchOnWindowFocus: false,
    },
  },
});

async function bootstrap() {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element #root not found in document.');

  try {
    await loadRuntimeConfig();
  } catch (err) {
    createRoot(rootEl).render(
      <div role="alert" style={{ padding: 24, fontFamily: 'monospace' }}>
        <h1>Configuration error</h1>
        <p>{err instanceof Error ? err.message : String(err)}</p>
      </div>,
    );
    return;
  }

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ConsoleAuthProvider>
            <App />
          </ConsoleAuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
